<script>
import dayjs from 'dayjs'
import DateFormatToken from '@/constants/date/DateFormatToken'
import { DurationUnits } from '@/shared/constants/date/DurationUnits'

export default {
  name: 'NewRestrictionCreatorConfirmation',
  model: {
    prop: 'isShowing',
    event: 'change',
  },
  props: {
    isShowing: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedLocations: {
      type: Array,
      default: () => [],
    },
    message: {
      type: String,
      default: '',
    },
    from: {
      type: dayjs.Dayjs,
      default: null,
    },
    until: {
      type: dayjs.Dayjs,
      default: null,
    },
  },
  computed: {
    isShowingModel: {
      get() {
        return this.isShowing
      },
      set(val) {
        this.$emit('change', val)
      },
    },
    dateMessage() {
      if (!this.from && !this.until) return ''

      if (this.from && this.until) {
        return this.$t(
          'locationRestrictions.create.confirmation.durationMessageFromUntil',
          {
            from: this.from
              .locale(this.$i18n.locale)
              .format(DateFormatToken.LL),
            until: this.until
              .locale(this.$i18n.locale)
              .format(DateFormatToken.LL),
            days: this.until.diff(this.from, DurationUnits.DAY),
          }
        )
      }
      const date = this.from ?? this.until
      return this.$t(
        'locationRestrictions.create.confirmation.durationMessageFrom',
        {
          from: date.locale(this.$i18n.locale).format(DateFormatToken.LL),
        }
      )
    },
  },
  methods: {
    handleSave() {
      this.$emit('save')
    },
  },
}
</script>

<template>
  <v-dialog v-model="isShowingModel" width="500">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        <div>
          {{ $t('locationRestrictions.create.confirmation.title') }}
          <div class="text-subtitle-2">{{
            $t('locationRestrictions.create.confirmation.body')
          }}</div>
        </div>
        <v-spacer />
        <v-btn icon @click="isShowingModel = false"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-card-title>

      <v-card-text class="pt-2">
        <div>
          <div class="pb-2 black--text">{{
            $t(
              'locationRestrictions.create.confirmation.locationsToBeRestricted'
            )
          }}</div>
          <v-chip
            v-for="(selection, i) in selectedLocations"
            :key="i"
            color="grey lighten-3"
            small
            class="mr-1"
          >
            {{ selection.title }}
          </v-chip>
        </div>

        <div class="mt-4">
          <div class="pb-2 black--text">{{
            $t('locationRestrictions.create.confirmation.duration')
          }}</div>
          {{ dateMessage }}
        </div>

        <div class="mt-4">
          <div class="pb-2 black--text">{{
            $t('locationRestrictions.create.confirmation.messageToBeShown')
          }}</div>
          {{ message }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn text @click="isShowingModel = false">
          {{ $t('locationRestrictions.create.confirmation.cancelBtn') }}
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          text
          :loading="loading"
          data-testid="save-btn"
          @click="handleSave"
        >
          {{ $t('locationRestrictions.create.confirmation.acceptBtn') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
